'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper.js');
var Border = require('../common/Border');
var util = require('../../helper/util');
var propConst = require('../../constants/propConst');
var styleHelper = require('../../helper/styleHelper');
var ColorImage = require('../common/ColorImage');

var TableViewItem = React.createClass({
  render: function () {
    var text = this.props.text;
    var len = text.length;
    var iconIndex = text.lastIndexOf('-');//   text.search(/\-/);
    var shortText = text.slice(0, iconIndex);
    var icon = text.slice(iconIndex, len);
    var hasIcon = this.getIcon(icon);

    if(hasIcon) {
      shortText = util.Text.convertSpaceToNbsp(shortText,false);
    }else{
      shortText = util.Text.convertSpaceToNbsp(text,false);
    }

    var itemBorderStyle = {
      width: this.props.width - 20
    };

    /*border相关兼容修正*/
    if(this.props.showSeparator && !this.props.isLast){
      itemBorderStyle.borderBottom = '1px solid ' + this.props.separatorColor;
    }

    var iconSize = parseInt(this.props.iconSize);
    var imgStyle = {
      float: 'left',
      width: iconSize || 22,
      height: iconSize || 22
    };

    return (
      <div className="item" style={{
                width: this.props.width ,
                height: this.props.height,
                backgroundColor: this.props.backgroundColor,
                display: this.props.display?'block':'none',
                wordSpacing : -1
                 }}
           onClick={this.onSelfClick}>
        <div className="item-border" style={itemBorderStyle}>
          <div className="item-text" style={{
            width : this.props.width - iconSize - 20
          }}>
            <label>
              {shortText}
            </label>
          </div>
          {
            hasIcon &&
            <div className="item-icon" style={{
            left : this.props.width - iconSize - 20,
            top: (this.props.height-iconSize)/2,
            width: iconSize,
            height: iconSize,
          }}>
              <ColorImage style={imgStyle}
                          src={hasIcon}
                          color={this.props.iconColor}
              />
            </div >
          }
        </div>
      </div>
    );
  },

  onSelfClick: function (e) {
    if (this.props.onClick) {
      this.props.onClick(e, this.props.index);
    }
  },

  getIcon: function (cfg) {
    var url;
    switch (cfg.trim()) {
      case '->':
        url = 'Gt';
        break;
      case '-p':
        url = 'DocEmpty';
        break;
      case '-n':
        url = 'Pencil';
        break;
      case '-+':
        url = 'Plus';
        break;
      case '-f':
        url = 'Folder';
        break;
      case '-r':
        url = 'RightTriangle';
        break;
      case '-v':
        url = 'CheckMark';
        break;
    }
    if (url) {
      return assetsHelper.getIcon(url + '.png');
    }
    return null;
  }
});

var TableView = React.createClass({
  parseText: function () {
    var text = styleHelper.getText(this.props);
    text = util.Text.removeLastEmptyRow(text);
    return util.Text.delimitText(text, util.Text.DM_RETURN);
  },
  getInitialState: function () {
    return {selectedIndex: util.Int(this.props.selectedIndex)};
  },
  render: function () {
    var textItems = this.parseText();
    var itemH = util.Int(this.props.itemHeight);
    var h = styleHelper.getHeight(this.props);
    var w = styleHelper.getWidth(this.props);
    var bgColor = styleHelper.getBackgroundColor(this.props);
    var borderVisible = styleHelper.getPropertyValue(this.props, propConst.BORDER_VISIBLE);
    if(borderVisible){
      w -= 2;
    }

    var textSize = styleHelper.getFontSize(this.props);

    var style = {
      lineHeight: itemH + 'px',
      boxSizing: 'content-box',
      overflow: 'hidden'
    };
    styleHelper.StyleUtil(this.props, style).text().background().border();

    return (<div className="component component-TableView" style={style}>
      {
        textItems.map(function (itm, index) {
          var isLast = false;
          if(index === textItems.length-1) {      //最后一列不显示分割线
            isLast = true;
          }
          return (
            <TableViewItem
              key={index}
              height={itemH + 0.5}
              width={w}
              text={itm}
              index={index}
              display={itemH * (index + 1) < h}
              backgroundColor={this.state.selectedIndex === index ? this.props.selectedColor :bgColor}
              onClick={this.onSelected}

              showSeparator={this.props.showSeparator}
              separatorColor={this.props.separatorColor}
              iconColor={this.props.iconColor}
              iconSize={this.props.iconSize}

              isLast={isLast}
            />
          );
        }, this)
      }
    </div>);
  },
  onSelected: function (e, index) {
    this.setState({selectedIndex: index});
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onSelected);
  }
});

module.exports = TableView;



// WEBPACK FOOTER //
// ./src/views/Components/TableView.jsx